import Blacklight from "blacklight-frontend";
import Spotlight from "spotlight-frontend";

Blacklight.onLoad(function() {
  console.warn("Spotlight Activated");
  Spotlight.activate();
});

import "./tdl_resources_form"